import { useEffect, useState } from "react";
import ButtonWrap from "../../../components/template/ButtonWrap";
import Modal from "../../../components/template/Modal";
import Select from 'react-select';
import MainTitle from "../../../components/template/MainTitle";
import api from "../../../components/utils/api";
import SubTitle from "../../../components/template/SubTitle";

const LoadBenchmarkMergeRuleSelector = ({ value, setValue, onLoad, isLoadDisabled }) => {
    const [options, setOptions] = useState([])

    useEffect(() => {
        api.get('/api/benchmark-datasets/all')
            .then(res => setOptions(res.data.benchmark_datasets.map(e => ({ label: e.name, value: e.id, classes: e.benchmark_dataset_classes }))))
            .catch(error => console.error(error))
    }, [])

    return (
        <div className="grid gap-2">
            <MainTitle title={'Load Benchmark Merge Rule'} />
            <SubTitle title="Benchmark Datasets" />
            <p className="text-left text-sm text-gray-500">To evaluate a model with a benchmark dataset, you need a merge rule whose tag names match the dataset classes.</p>
            <Select
                options={options}
                value={value}
                onChange={setValue}
            />
            <div className="text-right">
                <ButtonWrap contents={'Load'} onClick={onLoad} isDisabled={isLoadDisabled || !(value && value.hasOwnProperty('classes'))} />
            </div>
        </div>

    )
}

const LoadBenchmarkMergeRule = ({ setMergeRuleName, setExistMergeRulePairs, setLoadNotice, dbVersion }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [benchmarkDataset, setBenchmarkDataset] = useState()
    const openModal = () => { setModalVisible(true); }
    const closeModal = () => { setModalVisible(false); }
    const onLoad = async () => {
        try {
            const res = await api.get(`/api/benchmark-datasets/${benchmarkDataset.value}/merge-rule`, { params: { db_version: dbVersion } })
            setMergeRuleName(`${benchmarkDataset.label}_`)
            setExistMergeRulePairs(res.data.tags)
            if (!res.data.resolved_db_version) {
                setLoadNotice(`No merge rule snapshot exists for ${benchmarkDataset.label}; loaded the dataset classes as empty tags.`)
            } else if (res.data.resolved_db_version !== res.data.requested_db_version) {
                setLoadNotice(`No merge rule snapshot for ${res.data.requested_db_version}; loaded the nearest one (${res.data.resolved_db_version}).`)
            } else {
                setLoadNotice("")
            }
            closeModal()
        } catch (error) {
            console.error(error)
            setLoadNotice(error.response?.data?.message || 'Failed to load the benchmark merge rule.')
            closeModal()
        }
    }

    return (
        <div className="mr-2">
            <ButtonWrap contents={'Load Benchmark Merge Rule'} onClick={openModal} />
            {modalVisible && <Modal
                visible={modalVisible}
                closable={true}
                maskClosable={true}
                onClose={closeModal}>{
                    <div><LoadBenchmarkMergeRuleSelector
                        value={benchmarkDataset}
                        setValue={setBenchmarkDataset}
                        onLoad={onLoad}
                        isLoadDisabled={!dbVersion}
                    /></div>
                }</Modal>}
        </div>
    )
}

export default LoadBenchmarkMergeRule